import { IdAssetBundleCalloutIcons } from "./IdAssetBundleCalloutIcons";
export var IdBuildingCalloutType;
(function (IdBuildingCalloutType) {
    IdBuildingCalloutType[IdBuildingCalloutType["Discount"] = 0] = "Discount";
    IdBuildingCalloutType[IdBuildingCalloutType["Idle"] = 1] = "Idle";
    IdBuildingCalloutType[IdBuildingCalloutType["FinishedProduction"] = 2] = "FinishedProduction";
    IdBuildingCalloutType[IdBuildingCalloutType["FinishedConstruction"] = 3] = "FinishedConstruction";
})(IdBuildingCalloutType || (IdBuildingCalloutType = {}));
export var buildingCalloutGetConfig = function (type, iconId) {
    switch (type) {
        case IdBuildingCalloutType.Idle:
            return [
                {
                    colliders: [
                        {
                            offset: [-40, -80],
                            size: [80, 120],
                            type: 0,
                        },
                    ],
                    id: IdAssetBundleCalloutIcons.CallOutBlue,
                },
                {
                    id: iconId,
                    offset: [0, -17],
                },
                {
                    id: IdAssetBundleCalloutIcons.InactiveOutlinedIcn,
                    offset: [33, -47],
                },
            ];
        case IdBuildingCalloutType.FinishedProduction:
            return [
                {
                    colliders: [
                        {
                            offset: [-35, -80],
                            size: [80, 120],
                            type: 0,
                        },
                    ],
                    id: IdAssetBundleCalloutIcons.CallOutYellow,
                },
                {
                    id: iconId,
                    offset: [0, -10],
                },
            ];
        case IdBuildingCalloutType.FinishedConstruction:
            return [
                {
                    colliders: [
                        {
                            offset: [-40, -80],
                            size: [80, 120],
                            type: 0,
                        },
                    ],
                    id: IdAssetBundleCalloutIcons.CallOutYellow,
                },
                {
                    id: IdAssetBundleCalloutIcons.CheckIcn,
                    offset: [0, -17],
                },
            ];
        case IdBuildingCalloutType.Discount:
            return [
                {
                    colliders: [
                        {
                            offset: [-40, -80],
                            size: [80, 120],
                            type: 0,
                        },
                    ],
                    id: IdAssetBundleCalloutIcons.CallOutWhite,
                },
                {
                    id: IdAssetBundleCalloutIcons.PrimeSaleIcn,
                    offset: [0, -17],
                },
            ];
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/buildingCalloutGetConfig.ts
// module id = 2145
// module chunks = 3